//libraries
import React from 'react';
import styled from 'styled-components';
import { Link as ReactRouterLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// styles
import { Link, Flex, ColumnedFlex } from 'shared/styledComponents';
import { H1, Title } from 'shared/typography';
import devices from 'theme/devices';

// assets
import leftImage from 'assets/images/connect-examples-section.svg';
import rightImage from 'assets/images/forProviders/main-section.svg';
import logo from 'assets/images/robyn-logo.png';

// custom components
import Layout from 'components/Layout';

const Wrapper = styled.div`
  background-color: #fbf7f2;
  width: 100%;
`;

const Container = styled(Flex)`
  padding: 80px 0;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  @media ${devices.mobile} {
    padding: 20px 0;
    justify-content: center;
  }
`;

const LeftImage = styled.img`
  width: 320px;
  transform: rotate(90deg);
`;

const Logo = styled.img`
  width: 220px;
`;

const ImageColumned = styled(ColumnedFlex)`
  padding: 40px 0;
  justify-content: space-between;
  align-items: center;
  @media ${devices.mobile} {
    display: none;
  }
`;

const RightImage = styled.img`
  width: 320px;
  transform: scaleX(-1);
  margin-top: auto;
`;

const PageTitle = styled(H1)`
  font-size: 80px;
  line-height: 92px;
  text-transform: capitalize;
  text-align: center;
  margin-bottom: 20px;
  @media ${devices.mobile} {
    margin-bottom: 10px;
  }
`;

const SubTitle = styled(Title)`
  font-size: 32px;
  margin-bottom: 60px;
  text-align: center;
  @media ${devices.mobile} {
    margin-bottom: 40px;
  }
`;

const PageLink = styled(Link)`
  font-size: 32px;
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;
  margin-bottom: 20px;
  text-decoration: underline;
`;

const NotFound = (): JSX.Element => (
  <Layout>
    <Wrapper>
      <Container>
        <ImageColumned>
          <LeftImage src={leftImage} />
          <Logo src={logo} />
        </ImageColumned>
        <ColumnedFlex>
          <PageTitle>Page Not Found</PageTitle>
          <SubTitle>but may we suggest these:</SubTitle>
          <PageLink as={ReactRouterLink} to="/find-providers?stageId=&serviceId=&specializationId=">
            Find A Provider
          </PageLink>
          <PageLink as={HashLink} to="#listYourPractice">
            List Your Practice
          </PageLink>
          <PageLink as={ReactRouterLink} to="/classes">
            Enroll In Parentbirth
          </PageLink>
          <PageLink as={ReactRouterLink} to="/journeys">
            Check Out Real Story
          </PageLink>
          <PageLink as={ReactRouterLink} to="/share-your-journey">
            Share Your Story
          </PageLink>
          <PageLink href="mailto: hello@wearerobyn.co">Contact Us</PageLink>
          <PageLink as={ReactRouterLink} to="/">
            Home
          </PageLink>
        </ColumnedFlex>
        <ImageColumned>
          <RightImage src={rightImage} />
        </ImageColumned>
      </Container>
    </Wrapper>
  </Layout>
);

export default NotFound;
